





























































import { CreateElement, VNode } from 'vue';
import { Component, Prop, Model, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs/unified-ui-framework/src/shared/sw-extended-vue';
import { dropdown, DropdownDirValues } from '@libs/unified-ui-framework/src/shared/dropdown-dir';
import { SwIcon } from '@libs/unified-ui-framework/src/shared/sw-icon';
import { domService } from '@libs/unified-ui-framework/src/shared/dom-service';
import { SelectOption } from '@libs/unified-ui-framework/src/shared/sw-select/types';
import SwSelectOption from '@libs/unified-ui-framework/src/shared/sw-select/sw-select-option.vue';
import { SwTextfield } from '@libs/unified-ui-framework/src/shared/sw-textfield';
import { SwIconButton } from '@libs/unified-ui-framework/src/shared/sw-icon-button';

const cssPrefix = 'sw-custom-select';

/**
 * @event change `(optionId: string)`
 */
@Component({
  directives: {
    dropdown,
  },
  components: {
    SwIcon,
    SwTextfield,
    SwIconButton,
  },
})
export default class SwSelect extends SwExtendedVue {
  @Model('change', { type: [Array, String], required: true })
  value: string | string[];

  @Prop({ type: Boolean, default: false })
  disabled: boolean;

  @Prop({ type: Array, required: true })
  options: SelectOption[];

  @Prop({ type: String, required: true })
  name: string;

  @Prop({ type: Boolean, default: false })
  full: boolean;

  @Prop({ type: Array })
  filteredOptions: SelectOption[];

  // @Prop({ default: false })
  // filterable: boolean;

  cssPrefix = cssPrefix;
  scopeId = String(Math.floor(Math.random() * 100000000000));

  isDropdownVisible: boolean = false;
  width: number = 180; // in order to get the width changing reactive
  filterStr: string = '';
  readyToSearch: boolean = false;

  get isMultiple(): boolean {
    return Array.isArray(this.value);
  }

  get selectedOptions(): SelectOption[] | SelectOption | undefined {
    if (this.value instanceof Array) {
      return this.options.filter((o: any) => (this.value.includes(o.id)));
    }
    return this.options.find(o => (o.id === this.value));
  }

  get submitValue() {
    if (Array.isArray(this.selectedOptions)) {
      return JSON.stringify(this.selectedOptions.filter(o => (o.value !== undefined))
        .map(o => (o.value)));
    }
    if (this.selectedOptions && this.selectedOptions.value) {
      return this.selectedOptions.value;
    }
    return '';
  }

  get optionsDropdownValue(): DropdownDirValues {
    return {
      withArrow: false,
      content: this.optionsDropdownContent,
      trigger: 'controlled',
      visible: !this.disabled && this.isDropdownVisible,
      placement: 'bottom-start',
      width: 400,
      maxWidth: 0,
      onClickOutsidePopper: () => { this.isDropdownVisible = false; },
    };
  }

  private renderDisplayLabels(h: CreateElement): VNode|string {
    const options = this.selectedOptions;
    const labelContainer = (<div></div>) as VNode;
    let isRenderFunc = false;
    if (typeof options === 'undefined') return '';
    if (options instanceof Array) {
      const labelNodes = options.map((o: any) => {
        // should we distinguish mixed labels including VNode/string.
        if (typeof o.label === 'function') isRenderFunc = true;
        return typeof o.label === 'function' ? o.label(h) : o.label;
      });
      if (isRenderFunc) {
        labelContainer.children = labelNodes;
        return labelContainer;
      }
      return labelNodes.join(',');
    }
    return typeof options.label === 'function' ? options.label(h) : options.label;
  }

  private optionsDropdownContent(h: CreateElement): VNode[] {// tslint:disable-line
    const nodes: VNode[] = [];
    const displayOptions = this.filteredOptions ? this.filteredOptions : this.options;

    displayOptions.forEach((option) => {
      let isSelected = false;
      if (this.selectedOptions instanceof Array) {
        isSelected = this.selectedOptions.find((o: SelectOption) => (o.id === option.id)) ? true : false;
      } else if (typeof this.selectedOptions !== 'undefined') {
        isSelected = (this.selectedOptions.id === option.id);
      }
      const node = (
        <SwSelectOption
          {...{ class: `${this.cssPrefix}__option-${this.scopeId}` }}
          props-selected={isSelected}
          props-disabled={option.id === ''}
          nativeOn-click={() => (this.onSelectOption(option))}
        >
        {
          typeof option.label === 'function' ? option.label(h) : option.label
        }
        </SwSelectOption>
      ) as VNode;
      nodes.push(node);
    });

    return nodes;
  }

  private onClickBox() {
    if (this.disabled) { return; }
    this.isDropdownVisible = !this.isDropdownVisible;
  }

  private onSelectOption(option: SelectOption) {
    if (!Array.isArray(this.selectedOptions)) {
      this.$emit('change', option.id);
      (this.$el as HTMLElement).focus();
      this.isDropdownVisible = false;
    } else {
      let newSelectedId = [];
      // push new option or pop it from selectedOptions
      if (this.selectedOptions.find((o: SelectOption) => (o.id === option.id))) {
        newSelectedId = this.selectedOptions.filter((o: SelectOption) => (o.id !== option.id))
          .map((o: SelectOption) => {  return o.id; });
      } else {
        newSelectedId = this.selectedOptions.map((o: SelectOption) => { return o.id; });
        newSelectedId.push(option.id);
      }
      this.$emit('change', newSelectedId);
    }
  }

  private onKeyUp() {
    const newValue = (this.$refs.searchBox as HTMLInputElement).value;
    this.filterStr = newValue;
    if (!this.readyToSearch) return;
    this.$emit('search', newValue);
  }

  private onFocusSearchBox(evt: Event) {
    this.readyToSearch = true;
    this.isDropdownVisible = true;
    evt.stopPropagation();
    const searchBox = this.$refs.searchBox as HTMLInputElement;
    this.$nextTick(() => {
      searchBox.focus();
    });
  }

  @Watch('isDropdownVisible')
  private onDropdownVisibleChange() {
    this.exitSearchMode();
    // if (this.isDropdownVisible) {
    //   this.$nextTick(() => {
    //     const optionsEls = document.querySelectorAll(`.${this.cssPrefix}__option-${this.scopeId}`);
    //     const selectOptEl = Array.from(optionsEls)
    //       .find((e) => {
    //         const inst = (e as any).__vue__ as SwSelectOption;
    //         if (!inst) { return false; }
    //         return inst.selected;
    //       });
    //     /** FIXME: use native scrollIntoView for now */
    //     if (selectOptEl) { selectOptEl.scrollIntoView(false); }
    //   });
    // }
  }

  private exitSearchMode() {
    if (this.isDropdownVisible) return;
    this.readyToSearch = false;
    setTimeout(() => { this.filterStr = ''; this.$emit('search', this.filterStr); }, 200);
  }

  private updateSizes() {
    this.width = (this.$el as HTMLElement).offsetWidth;
  }

  private mounted() {
    this.$nextTick(() => {
      this.updateSizes();
    });
    domService.resizeObserver.on(this.$el as HTMLElement, this.updateSizes);
  }

  private updated() {
    this.$nextTick(() => {
      this.updateSizes();
    });
  }

  private beforeDestroy() {
    domService.resizeObserver.off(this.$el as HTMLElement, this.updateSizes);
  }

  private render(h: CreateElement): VNode {// tslint:disable-line
    let labelNode: VNode | string = '';

    if (this.selectedOptions) {
      labelNode = this.renderDisplayLabels(h);
    }
    const rootNode = (
      <div
        class={[`${this.cssPrefix}`, 'sw-typo-default',
          'sw-flexbox', 'sw-flexbox--inline', 'sw-flexbox--center-items',
          {
            [`${this.cssPrefix}--disabled`]: this.disabled,
            [`${this.cssPrefix}--full`]: this.full,
          },
        ]}
        v-dropdown={this.optionsDropdownValue}
        tabindex={this.disabled ? undefined : 0}
        onClick={this.onClickBox}
      >
        <input type="hidden" name={name} value={this.submitValue} disabled={this.disabled} />
        <div class={[`${this.cssPrefix}__label`, 'sw-flexbox__flex']}>{labelNode}</div>
        <div
          class={[`${this.cssPrefix}__icon`, { [`${this.cssPrefix}__icon--active`]: this.isDropdownVisible },
            'sw-flexbox', 'sw-flexbox--center-items', 'sw-flexbox--center-justify',
          ]}
        >
          <sw-icon name="arrow-up" size={12} rotate={180} ></sw-icon>
        </div>
      </div>
    );

    return rootNode as VNode;
  }
}
